import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import { AppRoutes, routes } from 'router/models';

import { useCorporateContext } from '../CorporateContext';
import { validateOfferCode } from '../services';

export const useValidateOfferCode = ({
  onExpired,
  onSuspended,
  onNotRecognized,
}: {
  onExpired: () => void;
  onSuspended: () => void;
  onNotRecognized: () => void;
}) => {
  const { publicCode, onValidCode } = useCorporateContext();
  const navigate = useNavigate();
  const { account } = useParams<{ account: string }>();

  return useMutation({
    mutationFn: (offerCode: string) =>
      validateOfferCode({ publicCode, offerCode }),
    retry: 2,
    onSuccess(data, offerCode) {
      if (!data) {
        return;
      }

      if (data.succeeded) {
        onValidCode(offerCode);
        if (account) {
          navigate(routes[AppRoutes.CorporateOnboarding](account));
        }
      } else if (data.message.toLowerCase().includes('expired')) {
        onExpired();
      } else if (data.message.toLowerCase().includes('suspended')) {
        onSuspended();
      } else {
        onNotRecognized();
      }
    },
  });
};
